export const getAccessTokenFromLocalStorage = (): string => {
  // 1. Get the access token from the local storage
  const accessToken = localStorage.getItem("access_token");

  // 2. Return the access token
  return accessToken;
};

export const getLoungeIdFromLocalStorage = (): string => {
  // Try v1 format first (selectedLocal)
  const selectedLocal = localStorage.getItem("selectedLocal");
  if (selectedLocal) {
    return JSON.parse(selectedLocal).id;
  }
  // Fallback to v2 format (account_info.lounge)
  const accountInfo = localStorage.getItem("account_info");
  if (accountInfo) {
    return JSON.parse(accountInfo).lounge?.id;
  }
  return null;
};
